module.exports = __webpack_public_path__ + "img/failure-zhans.d7564888.png";